import { render, staticRenderFns } from "./StarBackground.vue?vue&type=template&id=0eeee66b&scoped=true"
import script from "./StarBackground.vue?vue&type=script&lang=js"
export * from "./StarBackground.vue?vue&type=script&lang=js"
import style0 from "./StarBackground.vue?vue&type=style&index=0&id=0eeee66b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeee66b",
  null
  
)

export default component.exports